import { type ID, ProjectActions } from '@octopus-do/octopus-project-core'
import type { AppThunk } from '@store/migrationActions/thunkActions/types'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { getCloneId, getId, randomShift } from '@store/utils'
import * as ActionTypes from '@storeOld/actions'

export const cloneExternalLink =
  ({ id }: { id: ID }): AppThunk =>
  (dispatch, getState) => {
    if (!id) {
      return
    }

    const externalLink = migrationProjectSelector.getProjectExternalLink(id)(
      getState()
    )

    if (!externalLink) {
      return
    }

    const { offset } = externalLink

    const initiator = getId()

    const clonedId = getCloneId(id, initiator)

    dispatch({
      type: ActionTypes.COMMIT_PROJECT_REQUEST,
      payload: [
        ProjectActions.externalLinks.clone({
          id,
          initiator,
        }),
        ProjectActions.externalLinks.updateOffset({
          id: clonedId,
          offset: randomShift(offset),
        }),
      ],
    })
  }
